<script lang="ts" setup>
const notify = useNotify();

// IMPORTANT: keep this at the top of the file
eventBus.on(Events.SERVICE_ERROR, (event) => notify.errorWithoutLog(event));

const { $http } = useNuxtApp();
const { initialize } = analyticsUtils();

const authStore = useAuthStore();
const stripeStore = useStripeStore();
const preferenceStore = usePreferenceStore();
const cartStore = useCartStore();

const loadPreference = async (): Promise<void> => {
  const preference = await $http.preference.get();

  if (!preference) {
    return;
  }

  preferenceStore.setPreference(preference);
};

await loadPreference();
await cartStore.load();
await stripeStore.loadPublishableKey();
await authStore.refreshProfile();

const gTag: string | null = preferenceStore.preference.general.gTag;

if (gTag) {
  initialize(gTag);
}

defineHead(preferenceStore.preference);

const description = preferenceStore.preference.general.seo?.description;
const openGraphImage = preferenceStore.preference.general.seo?.openGraphImage;

useSeoMeta({
  description,
  ogDescription: description,
  ogImage: openGraphImage || undefined,
});

onMounted(async () => {
  const { webSocket } = await useWebSocket();
  webSocket.on('preferences-update', preferenceStore.setPreference);
});

onUnmounted(async () => {
  const { webSocket } = await useWebSocket();
  webSocket.off('preferences-update');
  eventBus.off(Events.SERVICE_ERROR);
});
</script>

<template>
  <div>
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />

      <UNotifications />
      <UModals />
    </NuxtLayout>
  </div>
</template>
